// 与H5相同：仅拆分已净化的完整HTML分区，旧正文无法识别时整段保留。
export function activityRichTextSections(safeHtml, doc = globalThis.document) {
  if (!safeHtml) return [];
  const fallback = () => [{ title: '活动说明', content: safeHtml }];
  if (!doc?.createElement) return fallback();
  const template = doc.createElement('template');
  template.innerHTML = safeHtml;
  if (!template.content.textContent.trim() && !template.content.querySelector('img,table,video,audio')) return [];
  const nodes = [...template.content.childNodes].filter(node => node.nodeType !== 3 || node.textContent.trim());
  if (!nodes.length || nodes.some(node => node.nodeType !== 1 || node.tagName !== 'SECTION')) return fallback();
  const sections = [];
  for (const node of nodes) {
    const copy = node.cloneNode(true), heading = copy.firstElementChild;
    const generatedTitle = heading?.tagName === 'P' && heading.textContent.trim() === '首存奖励规则';
    if (!heading || (!generatedTitle && !/^H[1-6]$/.test(heading.tagName)) || !heading.textContent.trim()) return fallback();
    const title = heading.textContent.trim();
    heading.remove();
    if (copy.textContent.trim() || copy.querySelector('img,table,video,audio')) sections.push({ title, content: copy.outerHTML });
  }
  return sections;
}

export function hasActivityRewardTable(section) {
  const table = section?.rewardTable;
  return Boolean(Array.isArray(table?.columns) && table.columns.length && table.columns.every(value => typeof value === 'string' && value.trim()) &&
    Array.isArray(table.rows) && table.rows.length && table.rows.every(row => Array.isArray(row?.cells) && row.cells.length === table.columns.length && row.cells.every(value => typeof value === 'string')));
}

export function activityDescriptionIsRepeated(description, safeHtml, doc = globalThis.document) {
  if (!description || !safeHtml || !doc?.createElement) return false;
  const template = doc.createElement('template');
  template.innerHTML = safeHtml;
  const plain = value => String(value || '').replace(/\s+/g, ' ').trim();
  return [...template.content.querySelectorAll('p,h1,h2,h3,h4,li')].some(node => plain(node.textContent) === plain(description));
}

export function isActivityVenueSection(section) {
  if (section?.items?.length && section.items.every(item => item.kind === 'VENUE')) return !section.key;
  return Boolean(section?.title === '参与场馆' && !section.key && (section.items || []).every(item => !item.kind || item.kind === 'VENUE'));
}

export function exactActivityId(value) {
  if (typeof value === 'number' && !Number.isSafeInteger(value)) return '';
  const id = String(value ?? '');
  return /^[1-9]\d{0,18}$/.test(id) && BigInt(id) <= 9223372036854775807n ? id : '';
}

export function activityVenueRows(sections = []) {
  const rows = sections.filter(isActivityVenueSection).flatMap(section => section.items || []).filter(item => typeof item?.title === 'string' && item.title.trim()).map(item => ({
    id: item.kind === 'VENUE' && item.linkKind === 'VENUE' ? exactActivityId(item.linkValue) : '',
    name: item.title,
    detail: typeof item.detail === 'string' ? item.detail : '',
    imageUrl: item.imageUrl || ''
  }));
  return rows.map(row => ({ ...row, transferable: Boolean(row.id && rows.filter(other => other.id === row.id).length === 1) }));
}

// 场馆目录ID与会员钱包ID属于不同身份，导航只带目录ID，不携带金额或发起转账。
export function activityTransferUrl(activity, venueId) {
  const id = exactActivityId(activity?.id), venue = exactActivityId(venueId);
  if (!id || !venue) return '';
  return `/mine/finance/transfer?${new URLSearchParams({ activityId: id, venueId: venue, activityTitle: String(activity.title || '').slice(0, 80) })}`;
}

export function activityTransferContext(search) {
  const query = new URLSearchParams(search || '');
  const activityId = exactActivityId(query.get('activityId')), venueId = exactActivityId(query.get('venueId'));
  return activityId && venueId ? { activityId, venueId, title: (query.get('activityTitle') || '当前活动').slice(0, 80), returnUrl: `/activity/${activityId}` } : null;
}

export function activityTransferWallet(wallets, venueId) {
  const id = exactActivityId(venueId);
  const matches = id ? (wallets || []).filter(wallet => exactActivityId(wallet.catalogVenueId) === id) : [];
  return matches.length === 1 && exactActivityId(matches[0].id) && Number(matches[0].status) === 1 ? matches[0] : null;
}
